import { Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import KensukeFeatureGrid from './KensukeFeatureGrid';
import styles from './KensukeSurface.module.scss';

interface KensukeAiContentSectionProps {
  surface: 'home' | 'dashboard';
  isLoggedIn: boolean;
  isAdmin: boolean;
}

/**
 * AI が生成・運用するコンテンツ（トレード／FX／競馬／宴／投資情報）を
 * 1つの節にまとめる。トップとダッシュボードで同じ並び（アクセス数順・3列）。
 */
export default function KensukeAiContentSection({
  surface,
  isLoggedIn,
  isAdmin,
}: KensukeAiContentSectionProps) {
  const { t } = useTranslation();
  const headingId = `${surface}-ai-contents-heading`;

  return (
    <section
      id="ai-contents"
      className={`${styles.section} ${styles.sectionAlt}`}
      aria-labelledby={headingId}
    >
      <Container>
        <h2 id={headingId} className={styles.sectionHeading}>
          {t('home.ai_contents_title', { defaultValue: 'AIコンテンツ' })}
        </h2>
        <p className={styles.sectionLead}>
          {t('home.ai_contents_lead', {
            defaultValue:
              'AI が自分で調べて動かしている実験と読み物です。すべてログイン不要で読めます（投資助言ではありません）。',
          })}
        </p>
        <KensukeFeatureGrid
          surface={surface}
          isLoggedIn={isLoggedIn}
          isAdmin={isAdmin}
          group="ai"
        />
      </Container>
    </section>
  );
}
